<template>
	<div class="overlay-additional">
		<h2
			class="overlay-additional__title"
			v-html="$t('cart.additionalProducts.overlay.title')"
		/>
		<div class="overlay-additional__items">
			<div
				class="overlay-additional__item"
				v-for="product in additionalProducts"
				:key="product.rule.productId"
			>
				<component
					class="overlay-additional__item-icon"
					:is="icon(product.icon)"
				/>
				<div
					class="overlay-additional__item-name"
					v-html="product.name"
				/>

				<QuantityCounter
					:quantity="product.quantity"
					base-class="overlay-additional__item-quantity"
					@sub="quantityItemSubstract(product)"
					@add="quantityItemAdd(product)"
				/>
				<div
					class="overlay-additional__item-price"
					:class="{
						'overlay-additional__item-price--show': product.total > 0,
					}"
					v-html="$options.filters.fwgpricecent(product.total, 'long')"
				/>
			</div>
		</div>

		<div
			class="overlay-additional__total"
			v-html="$options.filters.fwgpricecent(this.additionalProductsTotal, 'long')"
		/>

		<div class="overlay-additional__buttons">
			<Button
				@click.prevent="onAdjust"
				class="overlay-additional__submit"
				:text="$t('cart.additionalProducts.overlay.acceptButton')"
				level="primary"
				type="button"
			/>
			<a
				class="overlay-additional__reset"
				href=""
				@click.prevent="onReset"
				v-html="$t('cart.additionalProducts.overlay.resetButton')"
			/>
		</div>
	</div>
</template>

<script>
import { mapGetters } from 'vuex'
import Button from '@/components/Button'
import QuantityCounter from '@/components/QuantityCounter'
import MixinQuantityList from '@/mixins/MixinQuantityList'
import GenericMixin from '@/mixins/GenericVueMixin'

export default {
	mixins: [
		MixinQuantityList,
    GenericMixin,
	],
	components: {
		Button,
		QuantityCounter,
	},
	data() {
		return {
			quantityMin: 0,
			quantityBase: 0,
			quantityMax: 30,
		}
	},
	computed: {
		...mapGetters("additionalproducts", [
			"additionalItemRules",
			"additionalItems"
		]),
		...mapGetters('loader', [
			'isLoading',
		]),
		loading: {
			set(value) {
				this.$store.dispatch('loader/setLoading', value);
				this.$emit('loading', value);
			},
			get() {
				return this.isLoading;
			}
		},
		additionalProducts() {
			return this.additionalItemRules
				.reduce((prev, rule) => {
					let products = rule.products.map((product) => {

						return {
							...product,
							id: product.code,
							quantity: this.quantityItemGet(product.code),
              quantityMax: rule.maxAmount,
							total: 0,
							icon: product.icon || 'sauce', // icon mock
							rule,
						}
					})
					products.forEach((product, i) => {
						let quantity = this.quantityItemGet(product.code)
						let quantityOther = i > 0
							? products[0].quantity
							: 0
						let quantityPaid = Math.min(Math.max(quantity + quantityOther - rule.grantedAmount, 0), quantity)
						product.quantityPaid = quantityPaid
						product.total = quantityPaid * product.variants[0].price
					})

					prev.push(
						...products
					)

					return prev
				}, [])
		},
		additionalProductsTotal() {
			return this.additionalProducts
				.reduce((prev, product) => prev + product.total, 0)
		}
	},
	watch: {
		edited(value) {
			this.$store.dispatch('additionalproducts/additionalProductsEdited', value);
		}
	},
	methods: {
		icon(name = 'sauce') {
			return 'SVG' + name[0].toUpperCase() + name.slice(1);
		},
		async onAdjust() {
			this.loading = true;
			try {
				await this.$store.dispatch('additionalproducts/additionalProductsAdjust', {
					products: this.additionalProducts.map(product => ({
						code: product.code,
						quantity: product.quantity
					}))
				})

				this.loading = false;
				this.$emit('close')
			} catch(err) {
				this.isDebug() && console.error("AdditionalProducts::adjust", err)
				this.handleErrorDialog(err, {
          callback: () => this.onAdjust()
        });
				this.loading = false;
			}
		},
		async onReset() {
			this.loading = true;
			try {
				await this.$store.dispatch('additionalproducts/additionalProductsReset', {})
				this.loading = false;
				this.$emit('close')
			} catch(err) {
				this.isDebug() && console.error("AdditionalProducts::reset", err)
				this.handleErrorDialog(err, {
          callback: () => this.onReset()
        });
				this.loading = false;
			}
		},
		async onClose() {
			if (this.edited) {
				const confirmed = await this.$store.dispatch('dialog/showDialog', {
					title: this.$t('cart.additionalProducts.dialog.title'),
					message: this.$t('cart.additionalProducts.dialog.message'),
					confirm: this.$t('cart.additionalProducts.dialog.confirm'),
					cancel: this.$t('cart.additionalProducts.dialog.cancel'),
				});
				if (confirmed) {
					return this.onAdjust();
				}
			}
			this.$emit('close')
		},
	},
	mounted() {
		this.additionalItems
			.forEach(v => {
				this.quantityItemSet({
					id: v.code,
					quantity: v.quantity,
				})
			});
		this.edited = false;
	}
}
</script>

<style>

</style>
